import { CheckCircle } from "lucide-react";

interface Props {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
}

export function ChecklistItem({ checked, onChange, label }: Props) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={`flex items-center gap-3 w-full p-4 rounded-xl border-2 transition-all active:scale-[0.98] text-left ${
        checked
          ? "border-success/40 bg-success/5"
          : "border-border hover:border-primary/30"
      }`}
    >
      <div className={`shrink-0 h-6 w-6 rounded-full border-2 flex items-center justify-center transition-colors ${
        checked ? "bg-success border-success" : "border-muted-foreground/30"
      }`}>
        {checked && <CheckCircle className="h-4 w-4 text-success-foreground" />}
      </div>
      <span className={`text-sm font-medium ${checked ? "text-foreground" : "text-muted-foreground"}`}>{label}</span>
    </button>
  );
}
